import React from "react";
import "./NoDataFound.scss";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../image/Image";

const NoDataFound = ({message}) => {
  return (
    <div className="data-not-found">
      <Image imagePath={AppIcons.NoDataFound} altText="Record Not Found" />
      <h5>{message || `No Data Found`}</h5>
    </div>
  );
}

export default NoDataFound;
